import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';

import { GridHeaderWithOverflow } from '../../../../../components/grid-header/grid-header-with-overflow';
import pageStyle from '../../../../grid-page.module.less';
import { PromotionalBanner } from '../../../../../components/promotional-banner';
import { purchaseOrderEmptyStateMessages } from './purchase-order-empty-state.messages';
import PurchaseOrderIcon from '../../../../../svgs/purchase-order.svg';
import styles from './purchase-order-empty-state.styles.module.less';

/**
 * Empty state component shown when Purchase Orders feature is not available
 * Displays promotional content and upgrade path to subscription modal
 * @param {object} props - Component props
 * @param {object} props.view - View configuration for the grid header
 * @returns {JSX.Element} The purchase order empty state component
 */
export const PurchaseOrderEmptyState = ({ view }) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleUpgradeClick = useCallback(() => {
    navigate('/settings/payments');
  }, [navigate]);

  const upgradeButton = (
    <Button onClick={handleUpgradeClick} theme='promotional'>
      {intl.formatMessage(purchaseOrderEmptyStateMessages.upgradeNow)}
    </Button>
  );

  return (
    <div className={pageStyle['main-content']}>
      <div className={pageStyle['grid-header']}>{view && <GridHeaderWithOverflow view={view} />}</div>
      <div className={pageStyle['grid-content']}>
        <FlexColumn className={styles['empty-state-container']}>
          <img
            alt={intl.formatMessage(purchaseOrderEmptyStateMessages.emptyStateHeader)}
            className={styles['empty-state-icon']}
            src={PurchaseOrderIcon}
          />

          <div className={styles['empty-state-content']}>
            <Text
              className={styles['empty-state-header']}
              textType={TextType.H3}
              value={purchaseOrderEmptyStateMessages.emptyStateHeader}
            />

            <Text
              className={styles['empty-state-description']}
              textType={TextType.Paragraph}
              value={purchaseOrderEmptyStateMessages.emptyStateDescription}
            />

            <Text
              className={styles['empty-state-sub-description']}
              textType={TextType.Paragraph}
              value={purchaseOrderEmptyStateMessages.emptyStateSubDescription}
            />
          </div>

          <div className={styles['promotional-banner-container']}>
            <PromotionalBanner
              promotionalHeaderMessage={purchaseOrderEmptyStateMessages.upgradeToAccess}
              promotionalSubheaderMessage={purchaseOrderEmptyStateMessages.unlockFeature}
            >
              {upgradeButton}
            </PromotionalBanner>
          </div>
        </FlexColumn>
      </div>
    </div>
  );
};
